import setupMenu from './features/menu';
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

import htmx from 'htmx.org';
import {getCookie} from "./utils/globals.js";

window.htmx = htmx;

gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", e => {
    setupMenu();
    
    const externalLinks = [
        ...document.querySelectorAll("a[href^='http://']"),
        ...document.querySelectorAll("a[href^='https://']"),
        ...document.querySelectorAll("a[href*='.pdf']")
    ]

    externalLinks.forEach(elm => elm.setAttribute("target", "_blank"))
})


document.addEventListener("htmx:configRequest", (evt) => {
    let httpVerb = evt.detail.verb.toUpperCase();
    if (httpVerb === 'GET') return;

    let antiForgery = htmx.config.antiForgery;

    if (antiForgery) {

        // already specified on form, short circuit
        if (evt.detail.parameters[antiForgery.formFieldName])
            return;

        if (antiForgery.headerName) {
            evt.detail.headers[antiForgery.headerName]
                = antiForgery.requestToken;
        } else {
            evt.detail.parameters[antiForgery.formFieldName]
                = antiForgery.requestToken;
        }
    }
});

document.addEventListener("htmx:afterRequest", (evt) => {

})

document.addEventListener("closeModal", (evt) => {
    document.querySelector('[xp-cookie-banner]').classList.remove('is-active');
})

document.addEventListener("DOMContentLoaded", function () {

    let elements = Array.from(document.getElementsByTagName('lottie-player'));
    const collapseElm = document.getElementById("preferencesModal");
    if(collapseElm) {
        new bootstrap.Collapse(collapseElm, {
            toggle: false
        });
    }
    
    elements.forEach(elm => {
        elm.addEventListener('play', (e) => {
            e.target.shadowRoot.querySelector('svg').style.transform = '';
        });
    });

    const toggle = document.querySelector('[xp-cookie-banner-toogle]');
    console.log(toggle)
    toggle.addEventListener('click', (e) => {
        e.preventDefault();
        document.querySelector('[xp-cookie-banner]').classList.toggle('is-active');
        bootstrap.Collapse.getInstance(collapseElm)?.show();
    })
     
    collapseElm.addEventListener("show.bs.collapse", () => {
        document.getElementById("managePreferences").classList.add("d-none");
        document.getElementById("submitSelected").classList.remove("d-none");
    })
    collapseElm.addEventListener("hide.bs.collapse", () => {
        document.getElementById("managePreferences").classList.remove("d-none");
        document.getElementById("submitSelected").classList.add("d-none");
    })
});

const players = document.querySelectorAll('lottie-player');
if (players && players.length > 0) {

    const options = {
        root: document.body,
        rootMargin: '0px',
        threshold: 1.0
    };

    const ob = new IntersectionObserver((entries, observer) => {
        for (let entry of entries) {
            if (!entry.isIntersecting) {
                entry.target.stop()
            } else {
                console.log(entry)
                entry.target.play()
            }
        }
    }, options);

    players.forEach((item) => {
        ob.observe(item);
    });
}


